/* --------------------------------------------------------------------------
	Timeline
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-timeline').length) {
			return;
		}

		$('.js-timeline-item:even').addClass('odd');
		$('.js-timeline-item:odd').addClass('even');

		Site.OnResize.push(onResize);

		$('.js-timeline-toggle').on('activate.swap', onToggleActivate).on('deactivate.swap', onToggleDeactivate);

		hideLinks();
	}

	function onResize() {
		var minimum_height = $('.js-timeline-item:nth-child(1)').innerHeight() + $('.js-timeline-item:nth-child(2)').innerHeight() + 30;

		$('.js-timeline')
			.get(0)
			.style.setProperty('--timeline-height', minimum_height + 'px');
	}

	function onToggleActivate() {
		showLinks();
	}

	function onToggleDeactivate() {
		hideLinks();
	}

	function hideLinks() {
		$('.js-timeline-item').find('a').attr('tabindex', '-1');
		$('.js-timeline-item').eq(0).find('a').removeAttr('tabindex');
		$('.js-timeline-item').eq(1).find('a').removeAttr('tabindex');
	}

	function showLinks() {
		$('.js-timeline-item').find('a').removeAttr('tabindex');
	}

	Site.OnInit.push(init);
})(jQuery, Site);
